import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationContentPreview from "./InvestorCommunicationContentPreview";
import InvestorCommunicationVideoContentPreview from "./InvestorCommunicationVideoContentPreview";

const InvestorCommunicationSavedContentPreview = () => {
  const { investorCommunication, savedHeroImageSource, savedThumbnailSource } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  const { type, content, categoryIds, articleContent, videoContent } = investorCommunication;

  switch (type) {
    case "Article":
      return (
        <InvestorCommunicationContentPreview
          title={content?.title}
          categoryIds={categoryIds}
          htmlBody={articleContent?.htmlBody}
          heroImageSource={savedHeroImageSource}
        />
      );
    case "Video":
      return (
        <InvestorCommunicationVideoContentPreview
          title={content?.title}
          categoryIds={categoryIds}
          description={content?.description}
          videoUrl={videoContent?.videoUrl}
          thumbnailSource={savedThumbnailSource}
          allowDownload={videoContent?.allowDownload ?? false}
        />
      );
  }
};

export default InvestorCommunicationSavedContentPreview;
